
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Client, IContactModel, ContactModel, IClientUpdateModel, ClientUpdateModel } from '@/services/api.service';
import AddContact from './components/AddContact.vue';
import ContactCard from './components/ContactCard.vue';

@Component({
  components: {
    AddContact,
    ContactCard
  }
})
export default class ClientEdit extends Vue {
  public gid: string = '';
  public clientGid: string = '';

  public name: string = '';
  public addressLine1: string = '';
  public addressLine2: string = '';
  public addressLine3: string = '';
  public locality: string = '';
  public region: string = '';
  public postcode: string = '';

  public contacts: IContactModel[] = [];

  public inAddContactMode: boolean = false;
  public clientLoaded: boolean = false;

  protected mounted() {
    this.gid = this.$route.params.gid;
    this.fetchClient(this.gid);
  }

  private fetchClient(gid: string) {
    // @ts-ignore
    this.$Progress.start();
    const clientService: Client = new Client(process.env.VUE_APP_API_URL, this.$http);
    clientService.getClient(gid).then((data) => {
      this.name = data.name as string;
      this.addressLine1 = data.addressLine1 as string;
      this.addressLine2 = data.addressLine2 as string;
      this.addressLine3 = data.addressLine3 as string;
      this.locality = data.locality as string;
      this.region = data.region as string;
      this.postcode = data.postcode as string;
      this.contacts = data.contacts as ContactModel[];

      this.clientLoaded = true;
      // @ts-ignore
      this.$Progress.finish();
    });
  }
  private requestAddContact() {
      this.inAddContactMode = true;
  }

  private onAddContactCancelled() {
      this.inAddContactMode = false;
      (this.$refs.addcontactform as AddContact).clear();
  }
  private onContactAdded(contact: IContactModel) {
      console.log('Received contact-added event');
      console.log(contact);
      this.inAddContactMode = false;
      // Inject this Contact into the top of the list
      if (this.contacts === null) {
          this.contacts = [];
      }
      // Jam it into the list
      this.contacts.unshift(contact);
  }

  private updateClient() {
    console.log('updating client');
    const me = this;
    const updateModel: IClientUpdateModel = {
      gid: this.gid,
      name: this.name,
      addressLine1: this.addressLine1,
      addressLine2: this.addressLine2,
      addressLine3: this.addressLine3,
      locality: this.locality,
      region: this.region,
      postcode: this.postcode};

    const clientService: Client = new Client(process.env.VUE_APP_API_URL, this.$http);
    // @ts-ignore
    this.$Progress.start();
    clientService.updateClient(this.gid, new ClientUpdateModel(updateModel)).then((data) => {
      // Route to the edit client screen?
      // @ts-ignore
      this.$Progress.finish();
      // @ts-ignore
      this.$awn.success('Client ' + me.name + ' updated successfully');
    });
  }

  private cancelUpdateClient() {
    this.$router.push({ path: '/clients' });
  }
}
